import img from "../../../../assets/icons/mp-img3.svg";
import thick from "../../../../assets/icons/thick.svg";
import { Container, MpImg } from "./comonStyles";
import { ReactComponent as MpImgSVG } from "../../../../assets/icons/mp-img3.svg";
import {
  Separator,
  ServicesContianer,
  ServicesHeader,
  ServicesHeaderContainer,
  ServicesList,
  ServicesListItem,
  ServicesListItemIcon,
  ServicesListItemTextContainer,
  ServicesListItemHeader,
  ServicesListItemText,
} from "./itemListStyles";
import Icon from "../../../../components/icon";
import styled from "styled-components";
import { theme } from "../../../../helpers/theme";

const TypesOfGoods = () => {
  return (
    <>
      <Container>
        <MpImgGoodsContainer>
          <Icon width="100%" height="100%" icon={<MpImgSVG />} />
        </MpImgGoodsContainer>

        <ServicesContianer>
          <ServicesHeaderContainer>
            <ServicesHeader>Rodzaje towarów</ServicesHeader>
          </ServicesHeaderContainer>
          <Separator />
          <ServicesList>
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Neutralny</ServicesListItemHeader>
                <ServicesListItemText>
                  It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Medyczne</ServicesListItemHeader>
                <ServicesListItemText>
                  It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>
                  Artykuły spożywcze
                </ServicesListItemHeader>
                <ServicesListItemText>
                  It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
            <ServicesListItem>
              <ServicesListItemIcon src={thick} />
              <ServicesListItemTextContainer>
                <ServicesListItemHeader>Ciężkie ADR</ServicesListItemHeader>
                <ServicesListItemText>
                  It was popularised in the 1960s with the release of Letraset
                  sheets containing Lorem Ipsum passages
                </ServicesListItemText>
              </ServicesListItemTextContainer>
            </ServicesListItem>
            <Separator />
          </ServicesList>
        </ServicesContianer>
      </Container>
    </>
  );
};

export default TypesOfGoods;

const MpImgGoodsContainer = styled.div`
  width: 250px;
  height: 250px;
  margin-bottom: 50px;
  margin-top: 20px;

  @media ${theme.device.mobileL} {
    width: 300px;
    height: 300px;
  }

  @media ${theme.device.tablet} {
    width: 430px;
    height: 430px;
  }

  @media ${theme.device.laptopL} {
    width: 540px;
    height: 540px;
  }
`;
